import { Component, HostBinding, Input, OnInit } from "@angular/core";

import { WebComponentInitializerService } from "../shared/web-component-initializer.service";
import { TilslutningsanmodningComponent } from "../../../../common/src/lib/tilslutningsanmodning/tilslutningsanmodning.component";

@Component({
    selector: "dffedb-tilslutningsanmodning",
    templateUrl: "./dffedb-tilslutningsanmodning.component.html",
    styleUrls: ["./dffedb-tilslutningsanmodning.component.scss"],
    imports: [TilslutningsanmodningComponent]
})
export class DffedbTilslutningsanmodningComponent implements OnInit {
    public initialiserer = true;
    @HostBinding("class.mat-app-background") public classMatAppBackground = true;
    @Input() public nodeId: number;

    constructor(private readonly webComponentInitializer: WebComponentInitializerService) {}

    public ngOnInit(): void {
        this.webComponentInitializer.init(this.nodeId);
    }
}
